import React, { useCallback } from 'react'
import Image from 'components/image'
import { InfoButton } from 'components/buttons'
import { numberToCurrency } from 'lib/money'
import { reservationsPath } from 'lib/urls'
// @ts-ignore
import { track, useTracking } from 'lib/analytics'
import ExternalProductOffer from './ExternalProductOffer'
// @ts-ignore
import styles from './BabylistOffer.scss'

interface BabylistOfferWithDeliveryEstimatesProps {
  price: number
  regItem: any
  registry: any
  onClick: () => void
  inCart: boolean
  trackedCreateReservation: () => void
}

export const BabylistOfferWithDeliveryEstimates = ({
  price,
  regItem,
  registry,
  onClick,
  inCart,
  trackedCreateReservation,
}: BabylistOfferWithDeliveryEstimatesProps) => {
  const tracker = useTracking()
  const { isAvailableOnBabylist, offers } = regItem

  const showDeliveryEstimates =
    isAvailableOnBabylist && !!regItem.deliveryEstimate

  const handleAddToCart = useCallback(() => {
    if (typeof onClick !== undefined) {
      onClick()
    }

    tracker.trackEvent({
      event: track.registryProductOfferClicked,
      store: 'Babylist',
    })
  }, [onClick])

  return (
    <div className={styles.BabylistOffer}>
      <div className={styles.BabylistOffer__top}>
        <div className={styles.BabylistOffer__shopHeader}>
          <div className={styles.BabylistOffer__logo}>
            <Image
              src="//images.babylist.com/image/upload/v1631884941/bl_store_icon_o8u8vu.png"
              width={30}
            />
            <div className={styles.BabylistOffer__title}>Babylist Shop</div>
          </div>
          <div className={styles.BabylistOffer__price}>
            {numberToCurrency(price)}
          </div>
        </div>

        {showDeliveryEstimates && (
          <div className={styles.BabylistOffer__estimate}>
            <span className={styles.BabylistOffer__estimateTitle}>
              Estimated Arrival
            </span>
            <span className={styles.BabylistOffer__estimateDate}>
              {regItem.deliveryEstimate}
            </span>
            <span className={styles.BabylistOffer__estimateShower}>
              This gift will be delivered before the Baby Shower
            </span>
          </div>
        )}

        <div>
          {!isAvailableOnBabylist && (
            <small className={styles.BabylistOffer__outOfStock}>
              Item is currently out of stock
            </small>
          )}

          {inCart ? (
            <InfoButton
              block
              empty
              pill
              className="mtm pam"
              href={reservationsPath}
            >
              In Cart
            </InfoButton>
          ) : (
            <>
              <InfoButton
                block
                pill
                className="mtm pam"
                disabled={!isAvailableOnBabylist}
                onClick={handleAddToCart}
              >
                Add to Cart
              </InfoButton>

              <div className={styles.BabylistOffer__addSubtitle}>
                <span>Free shipping* 🚚</span>
                <span>Free returns 💗</span>
              </div>
            </>
          )}
        </div>
      </div>
      {offers ? (
        <div className={styles.BabylistOffer__offers}>
          <ExternalProductOffer
            offers={offers}
            regItem={regItem}
            registry={registry}
            trackedCreateReservation={trackedCreateReservation}
          />
        </div>
      ) : null}
    </div>
  )
}
